import React, { useEffect, useState, Fragment } from 'react';
import { Form, Input } from 'antd';
import '../SurveyAnswer.less';

interface ItemProps {
    text?: string;
    input: boolean;
    len: number;
}

// 填空题
const MvpFill: React.FC = ({ body, id, required, num, questionTypeId }: { body?: string; required?: boolean; num?: number; id?: number; questionTypeId?: number }) => {
    const [data, setData] = useState([]);

    // 处理填空 - 插入输入框
    const dealTitle = () => {
        if (body) {
            let arr = body.split(/_+/);
            let newTitle: any = body.match(/_+/g);
            let newArr: any = [];
            arr.forEach((item, index) => {
                if (item && index !== arr.length - 1) {
                    newArr.push({ text: item, input: true, len: newTitle ? newTitle[index]?.length : 1 });
                }
                if (item && index == arr.length - 1) {
                    newArr.push({ text: item, input: false, len: newTitle ? newTitle[index]?.length : 1 });
                }
                if (!item) {
                    newArr.push({ text: item, input: true, len: newTitle ? newTitle[index]?.length : 1 });
                }
            });
            setData(newArr);
        }
    };

    useEffect(() => {
        if (body && questionTypeId === 5) {
            dealTitle();
        }
    }, [body]);

    return (
        <>
            {questionTypeId === 5 ? (
                <Form.Item rules={[{ required, message: '该题为必答题，请作答后提交。' }]}>
                    <div className="fill-topic">
                        {data && data.length
                            ? data.map((item: ItemProps, index: number) =>
                                  item.input && item.len ? (
                                      <Fragment key={index}>
                                          <span className="fill-text">
                                              <i className={index === 0 && required ? 'show-required' : ''}></i>
                                              {index === 0 ? num + '. ' + item.text : item.text}
                                          </span>
                                          <Form.Item
                                              name={[`${id}-5`, index]}
                                              rules={[{ required, message: '该题为必答题，请作答后提交。' }]}
                                              // label={index === 0 ? (num + '. ' + item.text) : item.text}
                                              key={index}
                                          >
                                              <Input style={{ width: `${item.len * 0.18}rem` }} autoComplete="off" maxLength={200} />
                                          </Form.Item>{' '}
                                      </Fragment>
                                  ) : (
                                      <span key={index} className="fill-text">
                                          {data.length === 1 ? num + '. ' + item.text : item.text}
                                      </span>
                                  ),
                              )
                            : null}
                    </div>
                </Form.Item>
            ) : (
                <Form.Item name={[`${id}-4`, 0]} rules={[{ required, message: '该题为必答题，请作答后提交。' }]} label={num + '.' + body}>
                    <Input maxLength={200} />
                </Form.Item>
            )}
        </>
    );
};

export default MvpFill;
